<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="card p-2 p-sm-4">
        <h2 class="mb-4" style="font-size: 20px">🌴 Create Spot Booking</h2>
        <form [formGroup]="beachForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="card border-0 mb-4">
            <div class="card-header bg-light">
              <h5 class="mb-0">🏖️ Spot Information</h5>
            </div>
            <div class="card-body">
              <div class="row g-3 mb-2">
                <div class="col-md-6">
                  <label class="form-label"
                    >Spot Title <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    formControlName="title"
                    placeholder="Enter beach title"
                    [class.is-invalid]="
                      (submitted || beachForm.get('title')?.touched) &&
                      beachForm.get('title')?.invalid
                    "
                  />
                  <div
                    *ngIf="
                      (submitted || beachForm.get('title')?.touched) &&
                      beachForm.get('title')?.invalid
                    "
                    class="text-danger mt-1"
                  >
                    <div *ngIf="beachForm.get('title')?.errors?.required">
                      Title is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label"
                    >Spot Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    class="form-control"
                    formControlName="description"
                    placeholder="Description"
                    rows="1"
                    [class.is-invalid]="
                      (submitted || beachForm.get('description')?.touched) &&
                      beachForm.get('description')?.invalid
                    "
                  ></textarea>
                  <div
                    *ngIf="
                      (submitted || beachForm.get('description')?.touched) &&
                      beachForm.get('description')?.invalid
                    "
                    class="text-danger mt-1"
                  >
                    <div *ngIf="beachForm.get('description')?.errors?.required">
                      Description is required
                    </div>

                    <div
                      *ngIf="beachForm.get('description')?.errors?.minlength"
                    >
                      Minimum 10 characters required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row g-3 mb-4">
                <div class="col-12 col-md-6">
                  <label class="form-label mt-2">
                    Asset Type <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    formControlName="assetType"
                    [class.is-invalid]="
                      (submitted || beachForm.get('assetType')?.touched) &&
                      beachForm.get('assetType')?.invalid
                    "
                  >
                    <option value="" disabled selected>
                      Select asset type
                    </option>
                    <option *ngFor="let type of locktypes" [value]="type">
                      {{ type }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      (submitted || beachForm.get('assetType')?.touched) &&
                      beachForm.get('assetType')?.invalid
                    "
                    class="text-danger small"
                  >
                    Asset type is required
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label mt-2"
                    >Location Services <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-control"
                    formControlName="bookingLocationId"
                    required
                  >
                    <option value="" disabled selected>
                      Select a location
                    </option>
                    <option *ngFor="let d of locationList" [value]="d._id">
                      {{ d.title }}
                    </option>
                  </select>

                  <div
                    *ngIf="
                      (submitted ||
                        beachForm.get('bookingLocationId')?.touched) &&
                      beachForm.get('bookingLocationId')?.invalid
                    "
                    class="text-danger small"
                  >
                    Location Service is required
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label mt-2"
                    >Spot Category<span class="text-danger">*</span></label
                  >
                  <select
                    class="form-control"
                    formControlName="categoryId"
                    required
                    (change)="onCategoryChange()"
                  >
                    <option value="" disabled selected>
                      Select a Category
                    </option>
                    <option
                      *ngFor="let category of categoryList"
                      [ngValue]="category._id"
                    >
                      {{ category.name }}
                    </option>
                  </select>

                  <div
                    *ngIf="
                      (submitted || beachForm.get('categoryId')?.touched) &&
                      beachForm.get('categoryId')?.invalid
                    "
                    class="text-danger small"
                  >
                    Spot Category is required
                  </div>
                </div>
              </div>

              <div class="mb-4 mt-4">
                <h6 style="font-size: 16px">📅 Booking Schedule</h6>
              </div>
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label"
                    >Start Date <span class="text-danger">*</span></label
                  >
                  <input
                    type="date"
                    class="form-control"
                    formControlName="startDate"
                    [min]="isEdit ? null : today"
                    [class.is-invalid]="
                      (submitted || beachForm.get('startDate')?.touched) &&
                      beachForm.get('startDate')?.invalid
                    "
                  />
                  <div
                    *ngIf="
                      (submitted || beachForm.get('startDate')?.touched) &&
                      beachForm.get('startDate')?.invalid
                    "
                    class="text-danger small"
                  >
                    <div *ngIf="beachForm.get('startDate')?.errors?.required">
                      Start Date is required
                    </div>
                    <div
                      *ngIf="
                        !isEdit && beachForm.get('startDate')?.errors?.pastDate
                      "
                    >
                      Cannot select past dates
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label"
                    >End Date <span class="text-danger">*</span></label
                  >
                  <input
                    type="date"
                    class="form-control"
                    formControlName="endDate"
                    [min]="
                      beachForm.get('startDate')?.value ||
                      (isEdit ? null : today)
                    "
                    [class.is-invalid]="
                      (submitted || beachForm.get('endDate')?.touched) &&
                      beachForm.get('endDate')?.invalid
                    "
                  />
                  <div
                    *ngIf="
                      (submitted || beachForm.get('endDate')?.touched) &&
                      beachForm.get('endDate')?.invalid
                    "
                    class="text-danger small"
                  >
                    <div *ngIf="beachForm.get('endDate')?.errors?.required">
                      End Date is required
                    </div>
                    <div
                      *ngIf="beachForm.get('endDate')?.errors?.beforeFromDate"
                    >
                      Must be after Start Date
                    </div>
                    <div
                      *ngIf="
                        !isEdit && beachForm.get('endDate')?.errors?.pastDate
                      "
                    >
                      Cannot select past dates
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label"
                    >Check-in Time <span class="text-danger">*</span></label
                  >
                  <input
                    type="time"
                    class="form-control"
                    formControlName="checkInTime"
                    [class.is-invalid]="
                      (submitted || beachForm.get('checkInTime')?.touched) &&
                      beachForm.get('checkInTime')?.invalid
                    "
                  />
                  <div
                    *ngIf="
                      (submitted || beachForm.get('checkInTime')?.touched) &&
                      beachForm.get('checkInTime')?.invalid
                    "
                    class="text-danger small"
                  >
                    Check-in time is required
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label"
                    >Check-out Time <span class="text-danger">*</span></label
                  >
                  <input
                    type="time"
                    class="form-control"
                    formControlName="checkOutTime"
                    [min]="beachForm.get('checkInTime')?.value"
                    [class.is-invalid]="
                      (submitted || beachForm.get('checkOutTime')?.touched) &&
                      beachForm.get('checkOutTime')?.invalid
                    "
                  />
                  <div
                    *ngIf="
                      (submitted || beachForm.get('checkOutTime')?.touched) &&
                      beachForm.get('checkOutTime')?.invalid
                    "
                    class="text-danger small"
                  >
                    <div
                      *ngIf="beachForm.get('checkOutTime')?.errors?.required"
                    >
                      Check-out time is required
                    </div>
                    <div
                      *ngIf="
                        beachForm.get('checkOutTime')?.errors?.beforeCheckIn
                      "
                    >
                      Must be after check-in time
                    </div>
                  </div>
                </div>
              </div>

              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label"
                    >Timing <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-control"
                    formControlName="timing"
                    [class.is-invalid]="
                      (submitted || beachForm.get('timing')?.touched) &&
                      beachForm.get('timing')?.invalid
                    "
                  >
                    <option
                      *ngFor="let duration of slotDurations"
                      [value]="duration"
                    >
                      {{ duration }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      (submitted || beachForm.get('timing')?.touched) &&
                      beachForm.get('timing')?.invalid
                    "
                    class="text-danger small"
                  >
                    Slot duration is required
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label">
                    Duration <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    formControlName="duration"
                    [disabled]="beachForm.get('duration')?.disabled"
                    [class.is-invalid]="
                      (submitted || beachForm.get('duration')?.touched) &&
                      beachForm.get('duration')?.invalid
                    "
                  >
                    <option
                      *ngFor="let duration of durations"
                      [value]="duration"
                    >
                      {{ duration }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      (submitted || beachForm.get('duration')?.touched) &&
                      beachForm.get('duration')?.invalid
                    "
                    class="text-danger small"
                  >
                    Duration is required
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label"
                    >Vat Percentage <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    class="form-control"
                    formControlName="vatPercentage"
                    min="0"
                    max="100"
                    [class.is-invalid]="
                      (submitted || beachForm.get('vatPercentage')?.touched) &&
                      beachForm.get('vatPercentage')?.invalid
                    "
                  />
                  <div
                    *ngIf="
                      (submitted || beachForm.get('vatPercentage')?.touched) &&
                      beachForm.get('vatPercentage')?.invalid
                    "
                    class="text-danger small"
                  >
                    <div
                      *ngIf="beachForm.get('vatPercentage')?.errors?.required"
                    >
                      VAT percentage is required
                    </div>
                    <div *ngIf="beachForm.get('vatPercentage')?.errors?.min">
                      Must be 0% or more
                    </div>
                    <div *ngIf="beachForm.get('vatPercentage')?.errors?.max">
                      Must be 100% or less
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check mt-4">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      formControlName="isExclusive"
                      id="isExclusive"
                    />
                    <label class="form-check-label" for="isExclusive">
                      VAT Inclusive
                    </label>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Blocked Dates (Optional)</label>

                <div
                  *ngIf="shouldShowBlockedDates()"
                  formArrayName="blockedDates"
                >
                  <div
                    *ngFor="
                      let blockedDate of beachBlockedDates.controls;
                      let dateIndex = index
                    "
                    class="d-flex gap-2 mb-2"
                  >
                    <input
                      type="date"
                      class="form-control mr-2"
                      [formControlName]="dateIndex"
                      [min]="availableRange.min"
                      [max]="availableRange.max"
                      [disabled]="!availableRange.min || !availableRange.max"
                    />
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm mr-2"
                      (click)="addBlockedDate()"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      (click)="removeBlockedDate(dateIndex)"
                    >
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>

                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    (click)="addBlockedDate()"
                    *ngIf="beachBlockedDates.length === 0"
                  >
                    <i class="fas fa-plus"></i> Add Blocked Date
                  </button>

                  <div
                    *ngIf="beachBlockedDates.errors?.duplicate"
                    class="text-danger mt-1"
                  >
                    Duplicate dates are not allowed.
                  </div>
                  <div
                    *ngIf="beachBlockedDates.errors?.outOfRange && !isEdit"
                    class="text-danger mt-1"
                  >
                    Dates must be between Start Date and End Date.
                  </div>
                </div>

                <div *ngIf="!shouldShowBlockedDates()" class="text-muted small">
                  Select "Start Date" and "End Date" to enable blocked dates
                </div>
              </div>

              <div class="row g-3 mb-4">
                <div class="col-md-6">
                  <label class="form-label"
                    >Select Spot Location on Map
                    <span class="text-danger">*</span></label
                  >
                  <div *ngIf="showLocationError" class="text-danger mt-1">
                    Please select a location on the map
                  </div>
                  <div
                    id="storeLocationMap"
                    style="width: 100%; height: 250px; border-radius: 10px"
                    class="border rounded mb-2"
                  ></div>
                  <div class="mt-2">
                    <p class="mb-1">
                      <strong>Selected Location : </strong>
                      <span class="text-muted">{{
                        selectedLocation || "None selected"
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label">
                    Spot Image <span class="text-danger">*</span>
                  </label>

                  <div
                    class="upload-box position-relative border p-3 text-center"
                    (click)="!imagePreview && fileInput.click()"
                    [class.border-danger]="submitted && !beachImage"
                    style="cursor: pointer"
                  >
                    <!-- Add Icon -->
                    <ng-container *ngIf="!imagePreview">
                      <span class="plus-icon fs-2">+</span>
                      <p class="upload-text">Add Image</p>
                    </ng-container>

                    <!-- Preview Image with Delete -->
                    <div
                      *ngIf="imagePreview"
                      class="position-relative d-inline-block"
                    >
                      <img
                        [src]="imagePreview"
                        class="preview-image img-thumbnail"
                        alt="Preview"
                      />
                      <button
                        type="button"
                        class="delete-btn"
                        (click)="removeImage($event)"
                      >
                        &times;
                      </button>
                    </div>
                  </div>

                  <input
                    #fileInput
                    type="file"
                    hidden
                    accept="image/*"
                    (change)="onFileChange($event)"
                  />

                  <div
                    *ngIf="submitted && !beachImage"
                    class="text-danger mt-1"
                  >
                    Spot image is required
                  </div>
                </div>
              </div>
            </div>
          </div>

          <input type="hidden" formControlName="latitude" />
          <input type="hidden" formControlName="longitude" />
          <input type="hidden" formControlName="address" />

          <div class="card border-primary mb-4" formArrayName="zones">
            <div
              class="card-header d-flex justify-content-between align-items-center bg-light"
            >
              <h5 class="mb-0">🏖️ Spot Zones</h5>
              <button
                type="button"
                class="btn btn-warning btn-sm"
                (click)="addZone()"
              >
                <i class="fas fa-plus"></i> Add Zone
              </button>
            </div>
            <div class="card-body">
              <div
                *ngFor="let zone of zones.controls; let zoneIndex = index"
                [formGroupName]="zoneIndex"
                class="border rounded p-3 mb-3 position-relative"
              >
                <button
                  *ngIf="zoneIndex !== 0"
                  type="button"
                  class="btn btn-danger btn-sm m-2"
                  (click)="removeZone(zoneIndex)"
                  style="position: absolute; top: 0px; right: 0px"
                >
                  <i class="fas fa-times"></i>
                </button>
                <h6 class="text-primary mb-3">
                  Zone {{ zoneIndex + 1 }} Details
                </h6>

                <div class="row g-3 mb-3">
                  <div class="col-md-6">
                    <label class="form-label"
                      >Zone Name <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      formControlName="zoneName"
                      placeholder="Enter Zone Name"
                      [class.is-invalid]="
                        (submitted ||
                          zones.at(zoneIndex).get('zoneName')?.touched) &&
                        zones.at(zoneIndex).get('zoneName')?.invalid
                      "
                    />
                    <div
                      *ngIf="
                        (submitted ||
                          zones.at(zoneIndex).get('zoneName')?.touched) &&
                        zones.at(zoneIndex).get('zoneName')?.invalid
                      "
                      class="text-danger small"
                    >
                      Zone name is required
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label"
                      >Zone Type <span class="text-danger">*</span></label
                    >
                    <select
                      class="form-control"
                      formControlName="subCategoryId"
                      [class.is-invalid]="
                        (submitted ||
                          zones.at(zoneIndex).get('subCategoryId')?.touched) &&
                        zones.at(zoneIndex).get('subCategoryId')?.invalid
                      "
                      [disabled]="zoneTypes.length === 0"
                    >
                      <option value="" disabled selected>
                        Select Zone Type
                      </option>
                      <option *ngFor="let type of zoneTypes" [value]="type.id">
                        {{ type.name }}
                      </option>
                    </select>

                    <div
                      *ngIf="
                        (submitted ||
                          zones.at(zoneIndex).get('subCategoryId')?.touched) &&
                        zones.at(zoneIndex).get('subCategoryId')?.invalid
                      "
                      class="text-danger small"
                    >
                      Zone type is required
                    </div>
                    <div
                      *ngIf="
                        zoneTypes.length === 0 &&
                        beachForm.get('categoryId')?.value
                      "
                      class="text-warning small mt-1"
                    >
                      No zone types available for this category
                    </div>
                  </div>
                </div>
                <div class="row g-3 mb-3">
                  <div class="col-md-6">
                    <label class="form-label"
                      >Number of Rows <span class="text-danger">*</span></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      formControlName="numOfRows"
                      min="0"
                      max="8"
                      [class.is-invalid]="
                        zones.at(zoneIndex).get('numOfRows')?.invalid &&
                        (submitted ||
                          zones.at(zoneIndex).get('numOfRows')?.touched)
                      "
                    />
                    <div
                      *ngIf="
                        zones.at(zoneIndex).get('numOfRows')?.invalid &&
                        (submitted ||
                          zones.at(zoneIndex).get('numOfRows')?.touched)
                      "
                      class="text-danger small"
                    >
                      <div
                        *ngIf="
                          zones.at(zoneIndex).get('numOfRows')?.errors?.required
                        "
                      >
                        Rows are Required
                      </div>

                      <div
                        *ngIf="
                          zones.at(zoneIndex).get('numOfRows')?.errors?.max
                        "
                      >
                        Maximum 8 row is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label"
                      >Number of Columns
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      formControlName="numOfColumns"
                      min="0"
                      max="8"
                      [class.is-invalid]="
                        zones.at(zoneIndex).get('numOfColumns')?.invalid &&
                        (submitted ||
                          zones.at(zoneIndex).get('numOfColumns')?.touched)
                      "
                    />
                    <div
                      *ngIf="
                        zones.at(zoneIndex).get('numOfColumns')?.invalid &&
                        (submitted ||
                          zones.at(zoneIndex).get('numOfColumns')?.touched)
                      "
                      class="text-danger small"
                    >
                      <div
                        *ngIf="
                          zones.at(zoneIndex).get('numOfColumns')?.errors
                            ?.required
                        "
                      >
                        Columns are Required
                      </div>
                      <div
                        *ngIf="
                          zones.at(zoneIndex).get('numOfColumns')?.errors?.min
                        "
                      >
                        Minimum 1 Column is required
                      </div>
                      <div
                        *ngIf="
                          zones.at(zoneIndex).get('numOfColumns')?.errors?.max
                        "
                      >
                        Maximum 8 Columns is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label"
                    >Assets Included <span class="text-danger">*</span></label
                  >
                  <div formArrayName="assetsIncluded">
                    <div
                      *ngFor="
                        let asset of getAssetsArray(zoneIndex).controls;
                        let assetIndex = index
                      "
                      class="d-flex gap-2 mb-2"
                    >
                      <input
                        type="text"
                        class="form-control mr-1"
                        [formControlName]="assetIndex"
                        placeholder="e.g., 1x Umbrella, 2x Spot Chairs"
                        [class.is-invalid]="
                          (submitted || asset.touched) && asset.invalid
                        "
                      />
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm mr-1"
                        (click)="addAsset(zoneIndex)"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        (click)="removeAsset(zoneIndex, assetIndex)"
                        [disabled]="getAssetsArray(zoneIndex).length <= 1"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                    <div
                      *ngIf="
                        (submitted || getAssetsArray(zoneIndex).touched) &&
                        getAssetsArray(zoneIndex).invalid
                      "
                      class="text-danger small"
                    >
                      At least one asset is required
                    </div>
                  </div>
                </div>

                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label"
                      >Price <span class="text-danger">*</span></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      formControlName="price"
                      min="0"
                      step="1"
                      [class.is-invalid]="
                        (submitted ||
                          zones.at(zoneIndex).get('price')?.touched) &&
                        zones.at(zoneIndex).get('price')?.invalid
                      "
                    />
                    <div
                      *ngIf="
                        (submitted ||
                          zones.at(zoneIndex).get('price')?.touched) &&
                        zones.at(zoneIndex).get('price')?.invalid
                      "
                      class="text-danger small"
                    >
                      <div
                        *ngIf="
                          zones.at(zoneIndex).get('price')?.errors?.required
                        "
                      >
                        Price is required
                      </div>
                      <div
                        *ngIf="zones.at(zoneIndex).get('price')?.errors?.min"
                      >
                        Price must be positive
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label">
                    Zone Image <span class="text-danger">*</span>
                  </label>

                  <div
                    class="upload-box position-relative"
                    (click)="
                      !zoneImagePreviews[zoneIndex] &&
                        triggerZoneFileInput(zoneIndex)
                    "
                    [class.invalid]="
                      submitted && !zones.at(zoneIndex).get('zoneImage')?.value
                    "
                  >
                    <!-- Show Add button if no preview -->
                    <ng-container *ngIf="!zoneImagePreviews[zoneIndex]">
                      <span class="plus-icon">+</span>
                      <p class="upload-text">Add Image</p>
                    </ng-container>

                    <!-- Show Preview with Delete -->
                    <div
                      *ngIf="zoneImagePreviews[zoneIndex]"
                      class="position-relative d-inline-block"
                    >
                      <img
                        [src]="zoneImagePreviews[zoneIndex]"
                        class="preview-image img-thumbnail"
                      />
                      <button
                        type="button"
                        class="delete-btn"
                        (click)="removeZoneImage($event, zoneIndex)"
                      >
                        &times;
                      </button>
                    </div>
                  </div>

                  <input
                    type="file"
                    #zoneFileInput
                    hidden
                    accept="image/*"
                    (change)="onZoneImageChange($event, zoneIndex)"
                  />

                  <div
                    *ngIf="
                      submitted && !zones.at(zoneIndex).get('zoneImage')?.value
                    "
                    class="text-danger small"
                  >
                    Zone image is required
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-right">
            <button
              type="submit"
              class="btn btn-primary btn-md"
              [disabled]="beachForm.invalid && submitted"
            >
              <i class="fas fa-paper-plane"></i> Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #zoneWarningModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">🚫 Missing Zone</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Please add at least one zone to continue.</p>
    <div class="alert alert-warning mt-3">
      <i class="fas fa-exclamation-triangle mr-2"></i>
      Each beach must have at least one defined zone with pricing and
      availability information.
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      (click)="addZone(); modal.close('Add zone clicked')"
    >
      <i class="fas fa-plus mr-2"></i>Add Zone Now
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Cancel
    </button>
  </div>
</ng-template>
